import { useFluent_unstable } from '@fluentui/react-shared-contexts';
import { makeResetStyles } from '@griffel/react';
import { useCallback } from 'react';
// this style must be applied to the html element to disable scrolling
const useHTMLNoScrollStyles = makeResetStyles({
    overflowY: [
        'hidden',
        'clip'
    ],
    scrollbarGutter: 'stable'
});
/**
 * hook that disables body scrolling through `overflowY: hidden` CSS property
 */ export function useDisableBodyScroll() {
    const htmlNoScrollStyle = useHTMLNoScrollStyles();
    const { targetDocument } = useFluent_unstable();
    const disableBodyScroll = useCallback(()=>{
        var _targetDocument_defaultView;
        if (!targetDocument) {
            return;
        }
        var _targetDocument_defaultView_innerWidth;
        const isScrollbarVisible = ((_targetDocument_defaultView_innerWidth = (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.innerWidth) !== null && _targetDocument_defaultView_innerWidth !== void 0 ? _targetDocument_defaultView_innerWidth : 0) > targetDocument.documentElement.clientWidth;
        if (!isScrollbarVisible) {
            return;
        }
        targetDocument.documentElement.classList.add(htmlNoScrollStyle);
        return;
    }, [
        targetDocument,
        htmlNoScrollStyle
    ]);
    const enableBodyScroll = useCallback(()=>{
        if (!targetDocument) {
            return;
        }
        targetDocument.documentElement.classList.remove(htmlNoScrollStyle);
    }, [
        targetDocument,
        htmlNoScrollStyle
    ]);
    return {
        disableBodyScroll,
        enableBodyScroll
    };
}
